import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import moment from 'moment';

class Year extends Component {
  constructor(props) {
    super(props);

    this.state = {
      decade: (Math.floor(this.props.year / 10) * 10) || this.props.year
    }
    this.backDecade = this.backDecade.bind(this);
    this.forwardDecade = this.forwardDecade.bind(this);
  }
  backDecade(event) {
    event.preventDefault();
    this.setState({decade: this.state.decade - 10}); 
    return false; 
  }
  forwardDecade(event) {
    event.preventDefault();
    this.setState({decade: this.state.decade + 10});  
    return false;
  }
  render() {
    let display = "";
    if(this.props.selected) {
      display = this.props.year;
    }

    let allowDecadeForward = (moment().year() >= (this.state.decade + 10))
    let decadeForward = <div className="forward disabled" />
    if(allowDecadeForward) {      
      decadeForward = <DropdownItem className="forward" onClick={this.forwardDecade} toggle={false} />
    }

    let currMonthDay = `${this.props.month} ${this.props.day}`;
    if(!this.props.displayDay) {
      currMonthDay = this.props.month;
    }
    return (
        <Dropdown isOpen={this.props.isOpen} toggle={this.props.toggle}>
          <DropdownToggle name="year" id="year" tabIndex="-1">{display}</DropdownToggle>
          <DropdownMenu>
            <div className="close" onClick={this.props.toggle}></div>  
            <DropdownItem className="heading link" onClick={this.props.back}><div className="back"></div>{currMonthDay}</DropdownItem>            
            <div className="decade-selector">
              <DropdownItem className="back" onClick={this.backDecade} toggle={false} />
              <div className="decade">{this.state.decade}</div>
              {decadeForward}
            </div>
            {Array.from({length: 10}, (v, k) => k + this.state.decade).map((year, i) =>{
              let dropDownItem = <DropdownItem  name={year} onClick={this.props.select} active={year === this.props.year ? true : null}>{year}</DropdownItem>

              // Disable year if greater than today
              if(year > moment().year()) {
                dropDownItem = <DropdownItem disabled>{year}</DropdownItem>
              }
              return (
                <div className="dropdown-item-container" key={i}>
                  {dropDownItem}
                </div>
              );
            })}                            
          </DropdownMenu>          
        </Dropdown>       
      );
  }
}
Year.defaultProps= {
  isOpen: false,
  toggle: () => {},
  select: () => {},
  backToDay: () => {},
  year: 1980,
  selected: false,
  month: "",
  day: 1,
  displayDay: true
};

Year.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  select: PropTypes.func,
  back: PropTypes.func,
  year: PropTypes.number,
  selected: PropTypes.bool,
  month: PropTypes.string,
  day: PropTypes.number,
  displayDay: PropTypes.bool
};

export default Year;


// WEBPACK FOOTER //
// ./src/components/DatePicker/Year.js